const styles = theme => ({
  feesContainer: {
    padding: '1.5rem',
    '& p': {
      fontWeight: '600',
      lineHeight: '24px',
    },
  },
  totalContainer: {
    color: theme.palette.primary.main,
    borderTop: '1px solid #EBEEF3',
    padding: '1.5rem',
    fontWeight: '600',
    lineHeight: '24px',
  },
  [theme.breakpoints.down('sm')]: {
    feesContainer: {
      padding: '16px 10px',
      '& p': {
        lineHeight: '18px',
        forntSize: '12px',
      },
    },
    totalContainer: {
      padding: '16px 10px',
      lineHeight: '18px',
      forntSize: '12px',
    },
  },
});
export default styles;
